var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { PageNames } from '../../shared/page-names.enum';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { DtvCatalogUtils } from '../../utils/dtv-catalog/dtv-catalog.utils';
import { NavigationService } from '../../services/navigation/navigation.service';
import { BaseActions } from '../../shared/base-actions';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var ProductDetailInfoComponent = /** @class */ (function (_super) {
    __extends(ProductDetailInfoComponent, _super);
    function ProductDetailInfoComponent(stateService, navigationService) {
        var _this = _super.call(this) || this;
        _this.stateService = stateService;
        _this.navigationService = navigationService;
        _this.emitOrderProduct = new EventEmitter();
        _this.componentName = PageNames.DETAIL_PAGE_INFO;
        _this.columns2 = true;
        return _this;
    }
    ProductDetailInfoComponent.prototype.ngOnInit = function () {
        var packs = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        this.pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(packs, this.omapiId);
    };
    Object.defineProperty(ProductDetailInfoComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return ImageUtils.getBackgroundImageUrl(this.omapiId, 'info');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailInfoComponent.prototype, "bannerImageUrl", {
        get: function () {
            return ImageUtils.getBannerImageUrl(this.omapiId, 'info');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailInfoComponent.prototype, "logoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    ProductDetailInfoComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
    };
    ProductDetailInfoComponent.prototype.onEmitOrderProduct = function (event) {
        this.emitOrderProduct.emit(event);
    };
    return ProductDetailInfoComponent;
}(BaseActions));
export { ProductDetailInfoComponent };
